import { render, staticRenderFns } from "./SortColumn.vue?vue&type=template&id=420fc65e"
import script from "./SortColumn.vue?vue&type=script&lang=js"
export * from "./SortColumn.vue?vue&type=script&lang=js"
import style0 from "./SortColumn.vue?vue&type=style&index=0&id=420fc65e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports